import { render, staticRenderFns } from "./DHLExpress.vue?vue&type=template&id=c6265af2&scoped=true"
import script from "./DHLExpress.vue?vue&type=script&lang=js"
export * from "./DHLExpress.vue?vue&type=script&lang=js"
import style0 from "./DHLExpress.vue?vue&type=style&index=0&id=c6265af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6265af2",
  null
  
)

export default component.exports